import { catItem } from '../lib/catalog';
import { setAqua } from '../lib/aquaStore';

// no supply found: pick the object that feeds the network directly in the panel
export function SourcePick({ t, project, updateProject }) {
  const fits = (project.fittings || []).filter((f) => !['leak', 'valve', 'prv'].includes(f.type));
  const nm = (f) => f.name || catItem(f.catId)?.name || t['fit_' + f.type] || f.type;
  const pick = (id) => {
    updateProject((p) => ({ ...p, fittings: p.fittings.map((f) => (f.id === id ? { ...f, hyd: { ...(f.hyd || {}), src: true } } : f)) }));
    setAqua({ res: null });
  };
  return (
    <div className="aq-src-pick" data-testid="aq-src-pick">
      <p className="aq-err">{t.aqErr_noSource}</p>
      <p className="muted">{t.aqSrcPickHint}</p>
      {fits.map((f) => (
        <button key={f.id} className="chip" data-testid={`aq-src-pick-${f.id}`} onClick={() => pick(f.id)}>{nm(f)}</button>
      ))}
    </div>
  );
}
